import {
  GET_FEEDS_STATUS,
  RUN_FEED,
  UPDATE_FEED_STATUS,
  GET_FEEDS_FOR_DATE,
  RUN_FEED_WITH_COMMENTS,
  LOAD_FEED_SCHEDULE_ID,
  LOAD_FEED_CARD_DATA,
  GET_FEED_BREAKDOWN_INFO,
  GET_AUDIT_BREAKDOWN_INFO,
  STORE_FEED_BREAKDOWN_AUDIT_ID
} from '../action-types'
import {
  SET_FEED_ACTIVE_TOGGLE, SET_FEEDS_STATUS,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_FEED_BREAKDOWN_INFO,
  SET_AUDIT_BREAKDOWN_INFO,
  SET_FEED_BREAKDOWN_LOADING,
  SET_FEED_BREAKDOWN_LIST_SCROLL_TOP,
  SET_FEED_BREAKDOWN_ID,
  SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE,
  CLEAR_FEED_BREAKDOWN_RESULTS,
  SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE,
  SET_FEED_BREAKDOWN_AUDIT_ID,
  SET_FEED_CARD_DATA,
  SET_FEED_SCHEDULE_ID,
  SET_FEED_BREAKDOWN_SHOW_STATE,
  SET_FEED_AUDIT_LOADING
} from '../mutation-types'
import {informationTexts} from './information'
import server from '../server'
import axios from 'axios/index'
import moment from 'moment-es6'

const state = {
  feedStatus: [],
  breakdownInfos: [],
  // breakdownAuditInfos: [],
  // breakdown filters, loader, etc
  scheduleId: 0,
  isLoading: false,
  requestFromDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
  requestToDate: moment().format('YYYY-MM-DD'),
  filters: 'all',
  processDate: '',
  pageNumber: 0,
  pageSize: 20,
  sortBy: 'PROCESS_AUDIT_REQUEST_ID',
  ascDesc: 'DESC',
  // card feed info
  scheduledAt: '',
  offsetDays: 0,
  requiredEngagement: false,
  // pagination
  currentPage: -1,
  totalElements: 0,
  lastPage: false,
  scrollTop: 0,
  // detail audit table
  requestId: 0,
  auditLoading: false

}

const mutations = {
  [SET_FEED_BREAKDOWN_SHOW_STATE] (state, id) {
    const feedBreakdownInfo = state.breakdownInfos.find(int => int.id === id)
    feedBreakdownInfo.isOpen = !feedBreakdownInfo.isOpen
  },
  [SET_FEEDS_STATUS] (state, status) {
    state.feedStatus = status
  },
  [SET_FEED_ACTIVE_TOGGLE] (state, feedToggle) {
    state.feedStatus.filter(fl => fl.scheduleId === feedToggle.feed.scheduleId)[0].processActive = feedToggle.active
    if (!feedToggle.active && feedToggle.feed.requiredEngagement) {
      state.feedStatus.filter(fl => fl.processId === 'ENGAGEMENT_SCORES')[0].processActive = feedToggle.active
    }
  },
  [SET_FEED_BREAKDOWN_INFO] (state, loadState) {
    state.breakdownInfos = state.breakdownInfos.concat(loadState.breakdownInfos.map(breakdownInfo => {
      breakdownInfo.isOpen = false
      breakdownInfo.processAudits = []
      return breakdownInfo
    }))
    state.totalElements = loadState.totalElements
    state.isLoading = false
    state.currentPage += 1
    state.lastPage = loadState.lastPage
  },
  [SET_AUDIT_BREAKDOWN_INFO] (state, loadState) {
    const feedBreakdown = state.breakdownInfos.find(int => int.id === state.requestId)
    feedBreakdown.processAudits = loadState
  },
  [SET_FEED_BREAKDOWN_LOADING] (state, loading) {
    state.isLoading = loading
  },
  [SET_FEED_AUDIT_LOADING] (state, loading) {
    state.auditLoading = loading
  },
  [SET_FEED_BREAKDOWN_LIST_SCROLL_TOP] (state, scrollTop) {
    state.scrollTop = scrollTop
  },
  [SET_FEED_BREAKDOWN_ID] (state, scheduleId) {
    state.scheduleId = scheduleId
    state.breakdownInfos = []
    state.lastPage = false
    state.currentPage = -1
    state.requestFromDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
    state.requestToDate = moment().format('YYYY-MM-DD')
    state.processDate = ''
  },
  [SET_FEED_BREAKDOWN_AUDIT_ID] (state, requestId) {
    state.requestId = requestId
    state.breakdownAuditInfos = []
  },
  [SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE] (state, filters) {
    if (filters.startDate) {
      state.requestFromDate = filters.startDate
      state.requestToDate = filters.endDate
    }
  },
  [CLEAR_FEED_BREAKDOWN_RESULTS] (state) {
    state.breakdownInfos = []
    state.lastPage = false
    state.currentPage = -1
  },
  [SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE] (state, value) {
    state.processDate = value
  },
  [SET_FEED_SCHEDULE_ID] (state, scheduleId) {
    state.breakdownInfos = []
    state.lastPage = false
    state.currentPage = -1
    state.scheduleId = scheduleId
  },
  [SET_FEED_CARD_DATA]  (state, value) {
    const intSched = parseInt(value)
    const forDate = moment().format('YYYY-MM-DD')
    const actionData = { action: LOAD_FEED_CARD_DATA, data: forDate }
    server.getReplayable(`/core/connect/get/${forDate}`, actionData).then(response => {
      const feed = response.data.find(feed => feed.scheduleId === intSched)
      state.scheduledAt = moment(feed.nextTriggerDate).format('hh:mm')
      state.offsetDays = feed.processScheduleOffsetDays
      state.requiredEngagement = feed.requiredEngagement
    })
  }
}

let getFeedBreakdownAuditInfo = function (context, actionData) {
  return server.postReplayable(`/core/connect/feed/filter/breakdown`, {
    processAuditRequestId: context.state.requestId,
    feedStatus: 'all' // TODO: needs to be handled for filtering
  }, actionData)
}

let getFeedBreakdownInfo = function (context, actionData) {
  return server.postReplayable('/core/connect/feed/filter', {
    scheduleId: context.state.scheduleId,
    pageNumber: context.state.currentPage + 1,
    pageSize: context.state.pageSize,
    ascDesc: context.state.ascDesc,
    sortBy: context.state.sortBy,
    requestFromDate: context.state.requestFromDate,
    requestToDate: context.state.requestToDate,
    processDate: context.state.processDate,
    feedStatus: 'all' // TODO: needs to be handled
  }, actionData)
}

const actions = {
  [GET_FEEDS_STATUS] ({commit}, forDate) {
    const actionData = { action: GET_FEEDS_STATUS, data: forDate }
    server.getReplayable(`/core/connect/${forDate}`, actionData).then(response => {
      commit(SET_FEEDS_STATUS, response.data)
    })
    .catch(error => {
      console.log('Cannot retrieve feeds')
      console.log(error)
    })
  },
  [GET_FEEDS_FOR_DATE] ({commit}, forDate) {
    const actionData = { action: GET_FEEDS_FOR_DATE, data: forDate }
    server.getReplayable(`/core/connect/get/${forDate}`, actionData).then(response => {
      commit(SET_FEEDS_STATUS, response.data)
    })
      .catch(error => {
        console.log('Cannot retrieve feeds for the given date')
        console.log(error)
      })
  },
  [RUN_FEED] ({commit, dispatch, state}, {processId, scheduleId, date, fromDate}) {
    const processScheduleId = processId + scheduleId
    const actionData = { action: RUN_FEED, data: { processId, scheduleId, date } }
    let targetUrl
    if (fromDate === null) {
      targetUrl = `/core/connect/run/${processScheduleId}`
    } else {
      targetUrl = `/core/connect/run/${processScheduleId}/${fromDate}`
    }
    server.getReplayable(targetUrl, actionData).then(response => {
      const runningProcessScheduleId = response.data
      let infoKey
      if (runningProcessScheduleId.length === 0) {
        infoKey = informationTexts.FEED_UNABLE
      } else {
        infoKey = (runningProcessScheduleId === processScheduleId)
                ? informationTexts.FEED_STARTED : informationTexts.FEED_ALREADY_RUNNING
        dispatch(GET_FEEDS_FOR_DATE, date)
      }
      commit(SET_INFORMATION_SNACKBAR_TEXT, infoKey)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    })
  },
  [RUN_FEED_WITH_COMMENTS] ({rootState, state, dispatch, commit}, payload) {
    const processScheduleId = payload.processId + payload.scheduleId
    let targetUrl
    if (payload.fromDate === null) {
      targetUrl = `core/connect/run/comment/${processScheduleId}`
    } else {
      targetUrl = `core/connect/run/comment/${processScheduleId}/${payload.fromDate}`
    }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/${targetUrl}`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: { action: RUN_FEED_WITH_COMMENTS, data: payload }
    })
      .then((response) => {
        const runningProcessScheduleId = response.data
        let infoKey
        if (runningProcessScheduleId.length === 0) {
          infoKey = informationTexts.FEED_UNABLE
        } else {
          infoKey = (runningProcessScheduleId === processScheduleId)
            ? informationTexts.FEED_STARTED : informationTexts.FEED_ALREADY_RUNNING
          dispatch(GET_FEEDS_FOR_DATE, payload.date)
        }
        commit(SET_INFORMATION_SNACKBAR_TEXT, infoKey)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
      })
      .catch((err) => {
        console.log('Failed to re-run feed with comments')
        console.error(err)
      })
  },
  [UPDATE_FEED_STATUS] ({rootState, state, commit}, {scheduleId, active}) {
    const payload = { scheduleId, active }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/connect/active/${scheduleId}/${active}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: UPDATE_FEED_STATUS, data: payload}
    }).then((res) => {
      if (active) {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.FEED_ACTIVATED)
      } else {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.FEED_DEACTIVATED)
      }
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    }).catch((err) => {
      console.log('Failed to activate/deactivate feed')
      console.error(err)
    })
  },
  [GET_FEED_BREAKDOWN_INFO] (context) {
    const actionData = {action: GET_FEED_BREAKDOWN_INFO}
    if (context.state.isLoading || context.state.lastPage) {
      return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      context.commit(SET_FEED_BREAKDOWN_LOADING, true)
      getFeedBreakdownInfo(context, actionData)
          .then(result => {
            let data = {
              breakdownInfos: result.data.content,
              totalElements: result.data.totalElements,
              lastPage: result.data.last
            }
            context.commit(SET_FEED_BREAKDOWN_INFO, data)
            context.commit(SET_FEED_BREAKDOWN_LOADING, false)
            context.commit(SET_FEED_CARD_DATA, context.state.scheduleId)
            resolve(data)
          })
          .catch((err) => {
            console.error('Error fetching feeds', err)
            context.commit(SET_FEED_BREAKDOWN_LOADING, false)
            reject(err)
          })
    })
  },
  [GET_AUDIT_BREAKDOWN_INFO] (context) {
    const actionData = { action: GET_AUDIT_BREAKDOWN_INFO }
    context.commit(SET_FEED_AUDIT_LOADING, true)
    return new Promise((resolve, reject) => {
      getFeedBreakdownAuditInfo(context, actionData)
        .then(result => {
          let data = {
            breakdownAuditInfos: result.data
          }
          context.commit(SET_AUDIT_BREAKDOWN_INFO, data)
          context.commit(SET_FEED_AUDIT_LOADING, false)
          resolve(data)
        })
        .catch((err) => {
          console.error('Error fetching audit records for feed', err)
          reject(err)
        })
    })
  },
  [STORE_FEED_BREAKDOWN_AUDIT_ID] ({commit}, requestId) {
    commit(SET_FEED_BREAKDOWN_AUDIT_ID, requestId)
  },
  [LOAD_FEED_SCHEDULE_ID] (context, scheduleId) {
    context.commit(SET_FEED_SCHEDULE_ID, scheduleId)
  },
  [LOAD_FEED_CARD_DATA] ({commit}, scheduleId) {
    commit(SET_FEED_CARD_DATA, scheduleId)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/feedsModule.js